var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutopay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "white",
    stroke: "#BCE2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2155 11.9785C15.6663 11.9785 11.9785 15.6663 11.9785 20.2155C11.9785 24.7647 15.6663 28.4526 20.2155 28.4526C20.616 28.4526 21.0071 28.4142 21.3922 28.3588V21.3922C21.3922 19.9845 23.2836 19.0388 26.0991 19.0388C26.9617 19.0388 27.7364 19.1286 28.3977 19.2922C27.938 15.178 24.4521 11.9785 20.2155 11.9785ZM20.6078 20.2155C20.6078 20.432 20.4324 20.6078 20.2155 20.6078H16.2931C16.0762 20.6078 15.9009 20.432 15.9009 20.2155C15.9009 19.999 16.0762 19.8233 16.2931 19.8233H19.8233V16.2931C19.8233 16.0766 19.9986 15.9009 20.2155 15.9009C20.4324 15.9009 20.6078 16.0766 20.6078 16.2931V20.2155Z",
    fill: "#0189ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0992 28.4526C24.3651 28.4526 22.9836 28.0929 22.1768 27.4885V28.4526C22.1768 29.3469 23.863 30.0216 26.0992 30.0216C28.3353 30.0216 30.0216 29.3469 30.0216 28.4526V27.4885C29.2147 28.0929 27.8333 28.4526 26.0992 28.4526Z",
    fill: "#42A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0992 26.0991C24.3651 26.0991 22.9836 25.7395 22.1768 25.135V26.0991C22.1768 26.9934 23.863 27.6681 26.0992 27.6681C28.3353 27.6681 30.0216 26.9934 30.0216 26.0991V25.135C29.2147 25.7395 27.8333 26.0991 26.0992 26.0991Z",
    fill: "#42A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0992 23.7457C24.3651 23.7457 22.9836 23.386 22.1768 22.7816V23.7457C22.1768 24.64 23.863 25.3147 26.0992 25.3147C28.3353 25.3147 30.0216 24.64 30.0216 23.7457V22.7816C29.2147 23.386 27.8333 23.7457 26.0992 23.7457Z",
    fill: "#42A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0992 19.8233C23.863 19.8233 22.1768 20.498 22.1768 21.3923C22.1768 22.2866 23.863 22.9612 26.0992 22.9612C28.3353 22.9612 30.0216 22.2866 30.0216 21.3923C30.0216 20.498 28.3353 19.8233 26.0992 19.8233Z",
    fill: "#42A7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8276,
    height: 18.8276,
    fill: "white",
    transform: "translate(11.5862 11.5862)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopay);
export default __webpack_public_path__ + "static/media/autopay.10dc8a149b6a7b32a25b41aebab2adae.svg";
export { ForwardRef as ReactComponent };